import { computed } from 'mobx'
import ListStore from '../../../shared-lib/stores/ListStore'
import ExternalClientModel from './ExternalClientModel'
import { scopeData } from '../../lib/scopeData'

export type $ExternalClientStore = ExternalClientStore

export default class ExternalClientStore extends ListStore<ExternalClientModel> {
  fetchMethodName = 'externalClients'
  ModelClass = ExternalClientModel

  @computed get scopedItems() {
    const dataScopeId = this.rootStore.authStore.dataScopeId
    if (!dataScopeId) return this.items
    return scopeData(this.items, dataScopeId, 'ownerId')
  }

  addItems = async (data: Array<ExternalClientInput>) => {
    const { requester } = this.rootStore.communication

    try {
      const { addExternalClients } = await requester.addExternalClients({ data })

      return !!addExternalClients
    } catch (e) {
      console.error(e)
      return false
    }
  }

  switchClientBookings = async (clientId: string, toClientId: string) => {
    const { requester } = this.rootStore.communication

    try {
      const { switchClientBookings } = await requester.switchClientBookings({ data: { clientId, toClientId } })

      return !!switchClientBookings
    } catch (e) {
      console.error(e)
      return false
    }
  }
}
